<div class="row">
  <div class="col-md-3">
    <div class="label form-label">{{attribute.name}} {{ attribute.required ? '*' : ''}}</div>
    <div class="description" *ngIf="attribute.description">{{attribute.description}}</div>
  </div>
  <div class="col-md-9">
    <mat-form-field class="full" appearance="outline" color="warn">
      <mat-label>Choose an option</mat-label>
      <mat-select [formControl]="oneControl" [multiple]="multiple">
        <mat-option *ngFor="let op of ops" [value]="op.value">{{op.name}}</mat-option>
      </mat-select>
      <mat-error *ngIf="oneControl.invalid">Vui lòng nhập {{attribute.name}}</mat-error>
    </mat-form-field>
  </div>
</div>
